module.exports = __webpack_public_path__ + "static/media/map-sm.4506f5d8.svg";